import { Component, OnInit } from "@angular/core";
import {
  AbstractControl,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { NavController, NavParams } from "@ionic/angular";
import { Navigator } from "src/app/components/menu/navigator";
import { AuthenticationService } from "src/app/services/authentication/authentication.service";
import { ConfigService } from "src/app/services/config/config.service";
import { EMAIL_PATTERN } from "src/app/services/customFormValidators";

@Component({
  selector: "app-forgot-password",
  templateUrl: "./forgot-password.component.html",
  styleUrls: ["./forgot-password.component.scss"],
})
export class ForgotPasswordComponent implements OnInit {
  public isComplete: boolean = false;
  public email: AbstractControl;
  public emailForm: FormGroup;
  showForm: boolean = true;
  public responsibleGamingNumber: string;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public authService: AuthenticationService,
    public navigator: Navigator,
    protected config: ConfigService
  ) { }

  ngOnInit() {
    this.responsibleGamingNumber =
      this.config.getConfig().RESPONSIBLE_GAMING_NUMBER || "1-800-522-4700";
    this.emailForm = new FormGroup({
      email: new FormControl("", [
        Validators.pattern(EMAIL_PATTERN),
        Validators.required,
        Validators.maxLength(250)
      ]),
    });
    this.email = this.emailForm.get("email");
  }

  callForgotPassword() {
    this.emailForm.value.clientapp = this.config.getClientApp();
    this.authService.callForgotPassword(this.emailForm.value).subscribe(
      (response: any) => {
        this.isComplete = true;
        this.showForm = false;
      },
      (error) => {
        this.isComplete = true;
        this.showForm = false;
      }
    );
  }
}
